// extracted by mini-css-extract-plugin
export default {"root__btn":"style-module__root__btn___bcIZ3","root__counter":"style-module__root__counter___AnPV9","root__icon":"style-module__root__icon___RsrxH","root__heading":"style-module__root__heading____LZC1","root__heading_title":"style-module__root__heading_title___G8vmb","root__close":"style-module__root__close___cP3pc","root__content":"style-module__root__content___he2g7","root__wrapper":"style-module__root__wrapper___K4n6u"};
    if(module.hot) {
      // 1729151125991
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  